module.exports = __webpack_public_path__ + "static/media/zone5-garden.9eb7838e.png";